/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notif_Type_Payment_ReceivedInputs */

const vi_notif_type_payment_received = /** @type {(inputs: Notif_Type_Payment_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã nhận chuyển khoản`)
};

/**

* @param {Notif_Type_Payment_ReceivedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const notif_type_payment_received = /** @type {((inputs?: Notif_Type_Payment_ReceivedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notif_Type_Payment_ReceivedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_notif_type_payment_received(inputs)
});